module.exports = __webpack_public_path__ + "static/img/cardmapr-To2HQm-4688-unsplash_thumb.ed61f06.png";


//////////////////
// WEBPACK FOOTER
// ./static/img/ads/standard_bg/cardmapr-To2HQm-4688-unsplash_thumb.png
// module id = UALl
// module chunks = 4